import { CourseDef } from '../../../../types';
import L2084285 from './2084285';
import L2084286 from './2084286';
import L2084289 from './2084289';
import L3893646 from './3893646';
import L2084291 from './2084291';
// import L5234403 from './5234403';
import L5234404 from './5234404';

export const principiosDoTrader: CourseDef = {
  courseTitle: 'PRINCÍPIOS DO TRADER',
  lessons: [
    L2084285,
    L2084286,
    L2084289,
    L3893646,
    L2084291,
    // L5234403,
    L5234404,
  ],
};

